module.exports = __webpack_public_path__ + "img/sdg_en_(16).20e9b674.png";